
import Input from "../Input";
import Output from "../Output";

import switchImage from "../../assets/switch.png";
import { Helmet } from 'react-helmet-async';


import portugal from "../../assets/portugal.png";


function PortugalMagyar({ handleText, output, handleTarget, handleSource, langs, handleSwap, handleTranslate, text }) {


    return (

        <>
            <Helmet>
                <title>Portugál magyar fordító</title>
                <meta name='description' content="Ingyenes portugál magyar fordító szavakra, kifejezésekre, mondatokra. Akár teljes szöveg fordítása is." />
                <meta title="Portugál magyar fordító" />
                <link rel="canonical" href="https://online-fordito.hu/portugal-magyar-fordito" />
            </Helmet>
            <h1>Portugál magyar fordító</h1>
            <div className="wrapper">
                <div>
                    <Input handleText={handleText} handleSource={handleSource} langs={langs} text={text}></Input>
                    <button className="transbutton" onClick={handleTranslate}>Fordítás</button>
                </div>

                <button className="switch" onClick={handleSwap}><img src={switchImage}></img></button>


                <Output output={output} handleTarget={handleTarget} langs={langs} />

            </div>

            <section>

                <div className="sectionhead">
                    <h2>A portugál nyelvről</h2>
                    <img src={portugal} alt="Portugál zászló"></img>
                </div>

                <p>A portugál egy neo-latin nyelv, amelyet körülbelül 260 millió ember beszél világszerte. Portugália, Brazília, Mozambik, Angola, Zöld-foki-szigetek, Bissau-Guinea, São Tomé és Príncipe, valamint Kelet-Timor hivatalos nyelve. A portugál dallamos hangzásáról, kulturális sokszínűségéről, valamint a felfedezéshez és a kereskedelemhez fűződő történelmi kapcsolatairól ismert.</p>

                <p>A portugál írásrendszer a latin ábécét használja néhány diakritikus jellel. 26 betűből áll, köztük néhány egyedi hangból, mint például ã, õ és ç. A portugál kiejtése általában fonetikus, ami azt jelenti, hogy a szavakat úgy ejtik ki, ahogy írják őket, néhány regionális eltéréssel.</p>

                <p>Nyelvtana tartalmazza a főnév és a melléknév megegyezését a nemben és a számban, az igék ragozását és a nyelvtani névelők használatát. A főneveket hímnemű és nőnemű nemekre osztják, és a mellékneveknek meg kell egyezniük velük. Az igék ragozása idő, mód, aspektus és személy szerint történik.</p>

                <p>Szókincse latin gyökerű, és más nyelvekből származó kölcsönszavakat is tartalmaz, különösen az angolt és az egykori portugál gyarmatokon őshonos nyelveket. A portugálnak gazdag irodalmi hagyományai vannak, olyan befolyásos szerzőkkel, mint Luís de Camões, Fernando Pessoa és Machado de Assis.</p>

                <p>A portugál kultúra sokszínű, és tükrözi a különböző nyelvterületeket, ahol beszélik. Portugália és Brazília sajátos kulturális hagyományokkal rendelkezik, beleértve az irodalmat, a zenét, a táncot és a konyhát. A portugál nyelv tanulása betekintést nyújt a portugál nyelvű országok történelmébe, szokásaiba és értékeibe.</p>

                <p>A portugál nyelvtudás számos lehetőség előtt nyit ajtót. Brazília, a legnagyobb portugál nyelvű ország, gyorsan növekvő gazdasággal rendelkezik, és üzleti, kereskedelmi és befektetési lehetőségeket kínál. A portugál nyelv ismerete előnyös lehet a nemzetközi kapcsolatok, a fordítás, a turizmus és a kulturális csereprogramok terén.</p>

                <p>A portugál nyelvet más országokban és közösségekben is beszélik, például Angolában, Mozambikban és a Zöld-foki-szigeteken. A portugál nyelv ismerete megkönnyíti a kommunikációt és a kulturális megértést a luzofon világban, elősegíti a kapcsolatokat és gazdagítja a személyes és szakmai tapasztalatokat.</p>


            </section>
        </>

    )
}

export default PortugalMagyar;